import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import { Theme } from '../../config/constants';

const NoAccessLanding = () => {
  const navigate = useNavigate();
  const onLogout = () => {
    navigate('/logout');
  }

  return (
   <Col style={{height: '100vh'}}>
    { isMobile ? 
      <Fragment>
        <div style={{height: '100%'}}>
          <Row className='d-flex mt-5 justify-content-center'>
            <Col className='w-fc'>
              <div className='main-header text-size-24 justify-content-center'>No Access</div>
              <div className='text-size-16 justify-content-center'>This account does not have access to this portal.</div>
              <Button outline onClick={onLogout} block color={Theme().colors.accentName} className='py-2 col-12 button-label'>Log Out</Button>
            </Col>
          </Row>
        </div> 
      </Fragment>
      : 
      <Col style={{height: '100%'}}>
        <Row className='d-flex mt-5 justify-content-center'>
          <Col className='w-fc'>
            <div className='main-header text-size-24'>No Access</div>
            <div className='text-size-16'>This account does not have access to this portal.</div>
            <Button outline onClick={onLogout} block color={Theme().colors.accentName} className='py-2 col-12 button-label'>Log Out</Button>
          </Col>
        </Row>
      </Col>
    }
    </Col>
  )
}

export default NoAccessLanding;
